<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content content-with-nav pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      title="Levensverhaal"
      intro="Vragen levensverhaal: deze verschijnen en hoeven enkel beantwoord te worden wanneer u wenst dat de voorganger het levensverhaal uitschrijft."
    />

    <!-- Content -->
    <v-row justify="center">
      <v-col
        class="center"
        cols="12"
        md="8"
        lg="6"
      >
        <v-select
          v-model="algemeneInfo.levensverhaalValue"
          base-color="primary"
          bg-color="white"
          color="primary"
          density="compact"
          item-title="longDescription"
          item-value="value"
          :items="levensverhaalOpties"
          label="Keuze"
          variant="outlined"
        />

        <p class="levensverhaal-info">
          <v-icon
            class="mr-1"
            color="#907322"
            size="18"
          >
            mdi-information-outline
          </v-icon>
          Uiteraard beslist u zelf welke onderwerpen wel en niet verteld worden. De vragen zijn een aanzet, maar uiteraard mag u meer vertellen dan de zakelijke gegevens van adressen en geboortedata. Dat maakt zo'n tekst net tot een mooi verhaal. Het is een algemene vragenlijst. Sommige zaken zijn misschien niet van toepassing. Deze mag u dan gewoon overslaan. Indien er gevoeligheden zijn, geef deze gerust ook aan, dan kunnen we hiermee rekening houden.
        </p>

        <template
          v-if="algemeneInfo.levensverhaalValue === constantMixin.codes.levensverhaal.values.voorganger"
        >
          <div
            v-for="(vraag, index) in levensverhaalVragen"
            :key="index"
            class="levensverhaal-vraag"
          >
            <h3 class="levensverhaal-vraag-title">
              {{ vraag.tekst }}
            </h3>
            <v-textarea
              v-model="algemeneInfo[vraag.field]"
              auto-grow
              base-color="primary"
              bg-color="white"
              color="primary"
              density="compact"
              rows="3"
              variant="outlined"
            />
          </div>
        </template>

        <div class="d-flex justify-end">
          <v-btn
            color="primary"
            rounded
            @click="SaveGeneralInfo"
          >
            <v-icon
              class="mr-1"
              size="18"
            >
              mdi-content-save-outline
            </v-icon>
            Opslaan
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Navigation -->
    <div class="samenstellen-nav">
      <div class="samenstellen-nav-inner">
        <v-btn
          v-if="samenstellenNavigation_PreviousItem"
          color="primary"
          :disabled="samenstellenNavigation_PreviousItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToPrevious"
        >
          <v-icon start>
            mdi-chevron-left
          </v-icon>
          {{ samenstellenNavigation_PreviousItem.title }}
        </v-btn>
        <span v-else />
        <v-btn
          v-if="samenstellenNavigation_NextItem"
          color="primary"
          :disabled="samenstellenNavigation_NextItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToNext"
        >
          {{ samenstellenNavigation_NextItem.title }}
          <v-icon end>
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <span v-else />
      </div>
    </div>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import constantMixin from '@/mixins/constantMixin'
import errorMixin from '@/mixins/errorMixin'
import samenstellenNavigationMixin from '@/mixins/samenstellenNavigationMixin'
import klantService from '@/services/klantService'

export default {
  name: 'LevensverhaalComponent',
  components: { PageHero },
  mixins: [
    authenticationMixin,
    commonMixin,
    constantMixin,
    errorMixin,
    samenstellenNavigationMixin
  ],
  data () {
    return {
      algemeneInfo: {},
      levensverhaalOpties: [],
      levensverhaalVragen: [
        { field: 'levensverhaalGeboorte', tekst: 'Waar en wanneer werd de overledene geboren?' },
        { field: 'levensverhaalOpgegroeid', tekst: 'Waar groeide hij/zij op?' },
        { field: 'levensverhaalOuders', tekst: 'Wat waren de namen van zijn/haar ouders?' },
        { field: 'levensverhaalGezin', tekst: 'Hoeveel broers of zussen had hij/zij? Vertels iets over het gezin waarin hij/zij werd geboren.' },
        { field: 'levensverhaalSchoolopleiding', tekst: 'Waar ging hij/zij naar school en hoe lang? Wat vertelde hij/zij hierover?' },
        { field: 'levensverhaalKindertijd', tekst: 'Wat vertelde hij/zij over zijn/haar kindertijd?' },
        { field: 'levensverhaalLoopbaan', tekst: 'Welk werk heeft hij/zij gedaan en waar heeft hij/zij gewerkt? Wanneer ging hij/zij met pensioen?' },
        { field: 'levensverhaalOntmoetingPartner', tekst: 'Hoe heeft hij/zij zijn/haar vrouw/man/partner leren kennen?' },
        { field: 'levensverhaalHuwelijk', tekst: 'Vond er een huwelijk plaats? Waar en wanneer? Vertel.' },
        { field: 'levensverhaalWoonplaatsen', tekst: 'Wat waren de woonplaatsen (na het huwelijk)?' },
        { field: 'levensverhaalKinderen', tekst: 'Wanneer werden de kinderen geboren? Vertel enkele herinneringen.' },
        { field: 'levensverhaalKleinkinderen', tekst: 'Wanneer werd hij/zij (over-)grootouder? Vertel enkele herinneringen.' },
        { field: 'levensverhaalHobbysPassies', tekst: 'Wat waren zijn/haar hobby\'s/passies? Vertel.' },
        { field: 'levensverhaalReizen', tekst: 'Welke reizen heeft hij/zij gemaakt?' },
        { field: 'levensverhaalLaatsteLevensfase', tekst: 'Hoe was de laatste fase van zijn/haar leven?' },
        { field: 'levensverhaalBewonderenswaardig', tekst: 'Wat was bewonderenswaardig in het leven van de overledene?' },
        { field: 'levensverhaalVerdriet', tekst: 'Wat heeft de overledene verdriet bezorgd?' },
        { field: 'levensverhaalNogTeVertellen', tekst: 'Wat moet er zeker nog verteld worden?' },
        { field: 'levensverhaalAfscheid', tekst: 'Hoe verliep het afscheid?' }
      ]
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.samenstellen = true
    klantService.Init(this)
    this.LoadData()
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  },
  methods: {
    async LoadData () {
      this.CommonMixin_Load(this.$options.name, true)
      await Promise.all([
        this.GetLevensverhaalOpties(),
        this.GetLevensverhaal()
      ])
      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetLevensverhaalOpties () {
      const resp = await klantService.GetUitvaartDraaiboekListCode()

      if (resp?.data) {
        this.levensverhaalOpties = resp.data.filter(o => o.type === this.constantMixin.codes.levensverhaal.name)
      }
    },
    async GetLevensverhaal () {
      const resp = await klantService.GetUitvaartLevensverhaal()

      if (resp && (resp.data || resp.data !== '')) {
        this.algemeneInfo = resp.data
      }
    },
    async SaveGeneralInfo () {
      this.CommonMixin_Load(this.$options.name, true)
      await klantService.SaveUitvaartLevensverhaal(this.algemeneInfo)
      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
.levensverhaal-info {
  font-size: 14px;
  color: #6b6b6b;
  padding: 0;
  margin: 0 0 24px 0;
}

.levensverhaal-vraag {
  margin-bottom: 16px;
}

.levensverhaal-vraag-title {
  font-size: 14px;
  font-weight: 600;
  color: #907322;
  margin: 0 0 8px 0;
  padding: 0;
}
</style>
